import { MOBILE_BREAKPOINT } from './constants.js'

const mql =
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`)
    : null

export function isMobileViewport() {
  return mql ? mql.matches : false
}

export function createMobileWatcher({ onEnter, onLeave }) {
  const sync = (matches) => {
    if (matches) {
      onEnter?.()
    } else {
      onLeave?.()
    }
  }
  const handler = (event) => sync(event.matches)

  return {
    start() {
      if (!mql) return
      sync(mql.matches)
      mql.addEventListener('change', handler)
    },
    stop() {
      mql?.removeEventListener('change', handler)
    }
  }
}
